import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-wa-card',
	templateUrl:'./WaCardPluginCompPage.html',
	styles: [],
	styleUrls:['./WaCardPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaCardPluginCompPage
{
	mdContent_1125 = `\`\`\`java
import com.jwebmp.webawesome.components.card.WaCard;
\`\`\``;
	mdContent_1126 = `\`\`\`java
new WaCard&lt;&gt;()
\`\`\``;
	mdContent_1127 = `\`\`\`java
var card = new WaCard<>();
card.setAppearance(Appearance.Outlined);
var stack = new WaStack<>();
stack.add(new WaText<>().setText("Card Title"));
stack.add(new WaText<>().setText("Card body content"));
card.add(stack);
\`\`\``;
}
